export default {"src":"/login-app/[GIT_HASH]/_next/static/media/broadcast_on_home.84a78e66.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};